<template>
  <div class="divider">
    <div class="divider-left"></div>
    <div>{{ text }}</div>
    <div class="divider-right"></div>
  </div>
</template>

<script>
export default {
  name: 'Divider', // Vue2推荐显式声明组件名
  // 替换Vue3的defineProps，使用Vue2的props选项
  props: {
    text: {
      type: String,
      default: '分割线'
    }
  }
}
</script>

<style scoped>
/* 移除SCSS嵌套，转为普通CSS后代选择器 */
.divider {
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 0.3rem;
}

.divider .divider-left,
.divider .divider-right {
  flex: 1;
  height: 1.5px;
  background-color: #dbdfe9;
}

.divider .divider-left {
  margin-right: 0.2rem;
}

.divider .divider-right {
  margin-left: 0.2rem;
}
</style>